import React from 'react';
import { Spinner } from 'react-bootstrap';
import './Preloader.css';

/**
 * @description прелоадер
 * @returns {Element}
 * @constructor
 */
function Preloader() {
    return (
        <div className="preloader">
            <Spinner animation="border" variant="primary" />
        </div>
    );
}

export default Preloader;
